export default class HeaderNav {
  constructor(el) {
    this.el = el;

    this.toggleBtns = Array.from(this.el.querySelectorAll('[data-ptm-header-toggle]'));
    this.drawer = this.el.querySelector('[data-ptm-header-drawer]');
    this.overlay = this.el.querySelector('[data-ptm-header-overlay]');

    this.isOpen = false;
    this.lastFocused = null;

    this.onToggle = this.onToggle.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.init();
  }

  init() {
    if (!this.toggleBtns.length || !this.drawer) return;

    this.toggleBtns.forEach((btn) => btn.addEventListener('click', this.onToggle));

    if (this.overlay) {
      this.overlay.addEventListener('click', this.onOverlayClick);
    }

    document.addEventListener('keydown', this.onKeydown);

    // Sous-menus (mobile): toggle simple sur les boutons
    const submenuToggles = this.el.querySelectorAll('[data-ptm-submenu-toggle]');
    submenuToggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        // On remonte à l'item de navigation (drawer ou desktop)
        const item =
          btn.closest('.ptm-drawer__item--has-sub') ||
          btn.closest('.ptm-nav__item--has-sub') ||
          btn.closest('.ptm-nav__item');

        if (!item) return;

        const expanded = item.classList.toggle('is-subopen');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    // Ajout : fixed au scroll en mobile avec effet fluide
    let lastScroll = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!window.matchMedia('(max-width: 1250px)').matches) {
        this.el.classList.remove('ptm-header--fixed', 'ptm-header--hidden');
        return;
      }
      const currentScroll = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (currentScroll > 0) {
            this.el.classList.add('ptm-header--fixed');
            // Si on scroll vers le bas, on cache, sinon on montre
            if (currentScroll > lastScroll && currentScroll > 40) {
              this.el.classList.add('ptm-header--hidden');
            } else {
              this.el.classList.remove('ptm-header--hidden');
            }
          } else {
            this.el.classList.remove('ptm-header--fixed', 'ptm-header--hidden');
          }
          lastScroll = currentScroll;
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  open() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.lastFocused = document.activeElement;
    this.el.classList.add('is-open');
    document.documentElement.classList.add('ptm-lock');

    // aria-expanded : uniquement sur le burger (si présent)
    const mainToggle = this.toggleBtns[0];
    if (mainToggle) mainToggle.setAttribute('aria-expanded', 'true');

    // Focus premier élément focusable du drawer
    const firstFocusable = this.drawer.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable) firstFocusable.focus();
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.el.classList.remove('is-open');
    document.documentElement.classList.remove('ptm-lock');

    const mainToggle = this.toggleBtns[0];
    if (mainToggle) mainToggle.setAttribute('aria-expanded', 'false');

    if (this.lastFocused && this.lastFocused.focus) {
      this.lastFocused.focus();
    }
  }

  onToggle() {
    if (this.isOpen) this.close();
    else this.open();
  }

  onOverlayClick() {
    this.close();
  }

  onKeydown(e) {
    if (!this.isOpen) return;

    if (e.key === 'Escape') {
      this.close();
      return;
    }

    // Focus trap minimal
    if (e.key === 'Tab') {
      const focusables = this.drawer.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }
}
